var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"permission":"news","publication":true,"fields":_vm.fields,"updatePossible":true,"endpoint":"news","previewModule":"actueel","module":"news"},on:{"update":_vm.updateState}})}
var staticRenderFns = []

export { render, staticRenderFns }